import { render, staticRenderFns } from "./MailMiss.vue?vue&type=template&id=b5b07b5a&scoped=true&"
import script from "./MailMiss.vue?vue&type=script&lang=js&"
export * from "./MailMiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b07b5a",
  null
  
)

export default component.exports